import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClipboardIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 15.1 17",
	style: { enableBackground: "new 0 0 15.1 17" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.clipboard-icon-st0{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		className: "clipboard-icon-st0",
		d: "M11,3h2.4c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.2,0.2,0.4v11.9c0,0.1-0.1,0.3-0.2,0.4 c-0.2,0-0.4,0.1-0.5,0.1H1.7c-0.2,0-0.3-0.1-0.5-0.2C1.1,15.7,1,15.6,1,15.4V3.6c0-0.1,0.1-0.3,0.2-0.4C1.3,3.1,1.5,3,1.7,3H4"
	}), /* @__PURE__ */ _jsx("path", {
		className: "clipboard-icon-st0",
		d: "M4,5V4.3c0-0.9,0.4-1.7,1-2.4C5.7,1.4,6.6,1,7.5,1S9.3,1.4,10,2s1,1.5,1,2.4V5H4z"
	})] }) }) })]
});
export default SvgClipboardIcon;
